<template>
    <div class="material-selector">
        <Button type="primary" icon="ios-images" @click="showLibrary">从素材库选择{{ buttonTextComputed }}</Button>
        <MaterialLibrary
            v-model="showMaterialLibrary"
            :multiple="multiple"
            :fileType="fileType"
            :title="title"
            :groupId="groupId"
            @on-select="handleSelect"
            @on-cancel="handleCancel"
        />
    </div>
</template>

<script>
import MaterialLibrary from './MaterialLibrary.vue';

export default {
    name: 'MaterialSelector',
    components: {
        MaterialLibrary
    },
    props: {
        // 是否支持多选
        multiple: {
            type: Boolean,
            default: false
        },
        // 指定素材类型，可以是 'image', 'video', 'file'，不指定则默认图片
        fileType: {
            type: String,
            default: 'image'
        },
        // 分组ID
        groupId: {
            type: [String, Number],
            default: '10001'
        },
        // 模态框标题
        title: {
            type: String,
            default: '素材库'
        },
        // 按钮文本
        buttonText: {
            type: String,
            default: ''
        },
        // 当前值
        value: {
            type: [String, Array],
            default: ''
        }
    },
    data() {
        return {
            showMaterialLibrary: false
        };
    },
    computed: {
        buttonTextComputed() {
            if (this.buttonText) return this.buttonText;
            
            switch (this.fileType) {
                case 'image': return '图片';
                case 'video': return '视频';
                case 'file': return '文件';
                default: return '素材';
            }
        }
    },
    methods: {
        showLibrary() {
            console.log('Opening material library');
            this.showMaterialLibrary = true;
        },
        handleSelect(selectedItems) {
            this.$emit('success', selectedItems);
        },
        handleCancel() {
            console.log('Material library canceled');
            this.showMaterialLibrary = false;
        }
    }
}
</script>

<style lang="less" scoped>
.material-selector {
    display: inline-block;
}
</style> 